// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Menu_wrapper__2rQrO","list_menu":"Menu_list_menu__32fpx","item_title":"Menu_item_title__3JEEM","menu":"Menu_menu__268MX"};